import React, { useEffect } from "react";
import { ProgressBar } from "react-materialize";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import { notify } from "../../../helpers/helper";
import {
  counterPickupPrice,
  getAvailablePickups,
  getOrders,
} from "../../../redux/action/pickups";
import isEmpty from "lodash/isEmpty";
import { toDropLocation } from "../dropLocation";

export const IgnorePickup = ({ onClose, onConfirm }) => {
  return (
    <div>
      <h2>Ignore Pickup</h2>
      <p className="mt-1 mb-1">
        Are you sure you want to ignore this pickup? This action cannot be
        undone.
      </p>
      <div className="flex gap-1">
        <button onClick={onConfirm} className="modal-button red white-text">
          Ignore Pickup
        </button>
        <button
          onClick={onClose}
          style={{
            backgroundColor: "#ccc",
          }}
          className="modal-button"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export const AcceptPickupRecycler = ({
  organization,
  location,
  setLocation,
  item,
  index,
  accepting,
  notify,
  dispatch,
  acceptPickup,
  getAvailablePickups,
  getSingleOrder,
  scrap,
  orderLocation,
}) => {
  console.log("item in accept pickup", item);
  const { orders } = useSelector((state) => state.pickups);

  // First try to find order by item.order (direct reference)
  let order = orders.find((o) => o._id === item.order);

  // If order not found (either item.order is missing or points to non-existent order),
  // try to find the order by checking which order's pickups array contains this pickup
  // Match by _id first, then try matching by other properties as fallback
  if (!order) {
    order = orders.find((o) => {
      if (!o.pickups || !Array.isArray(o.pickups)) return false;

      // Try matching by _id first
      const matchById = o.pickups.some((pickup) => pickup._id === item._id);
      if (matchById) return true;

      // Fallback: match by scrap and generator if _id doesn't match
      // This handles cases where pickup objects might have different _id references
      const itemScrapId = item.scrap?._id || item.scraps?.[0]?._id;
      const itemGeneratorId = item.generator?._id;

      return o.pickups.some((pickup) => {
        const pickupScrapId = pickup.scrap?._id || pickup.scraps?.[0]?._id;
        const pickupGeneratorId = pickup.generator?._id;

        // Match if scrap and generator IDs match
        return (
          itemScrapId &&
          pickupScrapId &&
          itemScrapId === pickupScrapId &&
          itemGeneratorId &&
          pickupGeneratorId &&
          itemGeneratorId === pickupGeneratorId
        );
      });
    });
  }

  const loc = order?.location;

  useEffect(() => {
    setLocation(loc || "");
  }, [loc, setLocation]);

  return (
    <div>
      <p className="bold ">Accept pickup</p>

      <div
        style={{ alignItems: "center", marginVertical: 15 }}
        className="mt-1 mb-1 flex space-between  "
      >
        <div className="flex gap-1 align-center ">
          <img
            src="../images/scrap.png"
            style={{ width: "50px", height: "50px" }}
            alt="scrap"
          />
          <div className="flex column ">
            <p style={{ textTransform: "uppercase" }}>{scrap?.name}</p>
            <p className="grey-text">{scrap?.variant}</p>
          </div>
        </div>
        <div className="green-text align-center p-1 light-green  lighten-5  ">
          <p>
            <span className="black-text">Current Price</span> : {item?.currency} {scrap?.price}{" "}
          </p>

          {scrap?.priceChange?.generator?.to && (
            <p className="bold">
              <span className="black-text">Current Price</span> : ₹
              {scrap?.priceChange?.generator?.to || "N/A "}
            </p>
          )}
        </div>
      </div>

      {!order && (
        <div className="">
          <label className="black-text">
            Select a drop location for the pickup
          </label>
          <div className="row  ">
            <select
              className="input-style full-width browser-default "
              name="location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              disabled={loc ? true : false}
            >
              <option value={""}>--select--</option>
              {organization.locations?.map((location, i) => (
                <option value={location._id} key={i}>
                  {location.nickname}-{location.address}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}

      <div className="flex gap-1 mt-1">
        <button
          className="btn waves-effect waves-purple"
          onClick={(e) => {
            const elem = document.getElementById(item._id);

            const instance = window.M.Modal.getInstance(elem);
            e.preventDefault();
            // Find order using the same logic as above
            let foundOrder = orders.find((o) => o._id === item.order);

            // If order not found, try to find by checking pickups array
            if (!foundOrder) {
              foundOrder = orders.find((o) => {
                if (!o.pickups || !Array.isArray(o.pickups)) return false;

                // Try matching by _id first
                const matchById = o.pickups.some((pickup) => pickup._id === item._id);
                if (matchById) return true;

                // Fallback: match by scrap and generator if _id doesn't match
                const itemScrapId = item.scrap?._id || item.scraps?.[0]?._id;
                const itemGeneratorId = item.generator?._id;

                return o.pickups.some((pickup) => {
                  const pickupScrapId = pickup.scrap?._id || pickup.scraps?.[0]?._id;
                  const pickupGeneratorId = pickup.generator?._id;

                  return (
                    itemScrapId &&
                    pickupScrapId &&
                    itemScrapId === pickupScrapId &&
                    itemGeneratorId &&
                    pickupGeneratorId &&
                    itemGeneratorId === pickupGeneratorId
                  );
                });
              });
            }

            if (!foundOrder && !location) {
              return notify("Please select a drop location");
            }

            const loc = foundOrder
              ? organization.locations.find(
                (loc) => loc._id === foundOrder?.location
              )
              : organization.locations.find((loc) => loc._id === location);

            // Only send the fields the server needs for the drop location.
            const dropLocation = toDropLocation(loc);

            dispatch(
              acceptPickup(item._id, { dropLocation }, () => {
                notify("Pickup accepted successfully!");
                // Use foundOrder._id if available, otherwise try item.order
                const orderId = foundOrder?._id || item.order;
                if (orderId) {
                  dispatch(getSingleOrder(orderId));
                }
                dispatch(getAvailablePickups());
                instance.close();
              })
            );
          }}
        >
          {accepting ? <ClipLoader color="#fff" size={20} /> : "Accept Pickup"}
        </button>

        <button
          className="btn-outline waves-effect waves-purple "
          onClick={(e) => {
            const elem = document.getElementById(item._id);

            const instance = window.M.Modal.getInstance(elem);

            e.preventDefault();
            instance.close();
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export const CounterPickupPrice = ({
  scrap,
  pickup,
  order,
  setOrder,
  index,
}) => {
  const [price, setPrice] = React.useState("");
  const [quantity, setQuantity] = React.useState("");
  const dispatch = useDispatch();
  const { pickupPriceLoading } = useSelector((state) => state.pickups);
  const { orders } = useSelector((state) => state.pickups);
  const msa = orders.find((o) => o._id === pickup.order);

  const scrapPrice = msa?.scraps?.find((s) => s._id === scrap?._id)?.price;

  useEffect(() => {
    setQuantity(scrap.quantity);
    setPrice(scrap.price);
  }, [scrap]);

  function sendCounterPrice() {
    if (!price || !quantity) return;
    let data = { to: price, quantityTo: quantity || scrap.quantity };

    dispatch(
      counterPickupPrice(data, pickup._id, () => {
        notify(
          "Your proposed price has been sent.",
          "Awaiting confirmation from trader to reflect the price if accepted."
        );
        let elem = document.getElementById(pickup._id + "-counter-price");
        let instance = window.M.Modal.getInstance(elem);

        instance.close();

        // if (!order) {
        dispatch(getAvailablePickups());
        dispatch(getOrders());
        return;
      })
    );
  }

  return (
    <div style={styles.container}>
      {pickupPriceLoading && <ProgressBar />}
      <p className="bold">Counter Price/Quantity</p>
      <div
        style={{ alignItems: "center", marginVertical: 15 }}
        className="mt-1 mb-1 flex space-between  "
      >
        <div className="flex gap-1 align-center ">
          <img
            src="../images/scrap.png"
            style={{ width: "50px", height: "50px" }}
            alt="scrap"
          />
          <div className="flex column ">
            <p style={{ textTransform: "uppercase" }}>{scrap?.name}</p>
            <p className="grey-text">{scrap?.variant}</p>
          </div>
        </div>
        <div className="green-text align-center p-1 light-green  lighten-5  ">
          <p>
            <span className="black-text">Current Price</span> : {pickup?.currency} {scrap?.price}{" "}
          </p>

          <p>
            <span className="black-text">Current Quantity</span> :{" "}
            {pickup.scraps.find((s) => s._id === scrap._id)?.quantity ||
              pickup.quantity}{" "}
            {scrap.quantityUnit}
          </p>

          {scrap?.priceChange?.generator?.to && (
            <p>
              <span className="black-text">Announcement Price</span> : {pickup?.currency}
              {scrapPrice || "N/A "}
            </p>
          )}
        </div>
      </div>

      <section className="flex  gap-1">
        <div>
          <p htmlFor="">Enter Your Price</p>

          <div className="flex align-end gap-1">
            <p>{pickup?.currency}</p>
            <input
              placeholder={`Eg. ${pickup?.currency} 1000`}
              onChange={(e) => setPrice(e.target.value)}
              type="number"
              className="browser-default input-style "
              value={price}
            />
          </div>
        </div>

        <div>
          <p htmlFor="">Enter Your Quantity ({scrap.quantityUnit})</p>
          <div className="flex align-end gap-1">
            <input
              placeholder="Eg. 1000 "
              onChange={(e) => setQuantity(e.target.value)}
              type="number"
              className="browser-default input-style "
              value={quantity}
            />
            <p>{scrap.quantityUnit}</p>
          </div>
        </div>
      </section>

      <div className="flex p-1 lighten-5 purple rounded flex align-center gap-1 cercle-purple-text mt-2">
        <span
          className="material-symbols-outlined grey-text
        black-text"
        >
          info
        </span>
        <p>
          Trader will be notified of your counter price and quantity. If they
          accept, the price will be updated in the order.
        </p>
      </div>

      {scrap?.priceChange?.processor?.to && (
        <div
          className="orange-text align-center p-1 orange lighten-5 mt-1 "
          style={{ borderRadius: 10, border: "1px solid #ff9800" }}
        >
          <p>
            <span className="black-text">You sent a counter offer</span> :{" "}
            <span className="black-text"> From </span> {pickup?.currency}
            {scrap?.priceChange?.processor?.from || scrap?.price} /Kg (
            {scrap?.priceChange?.processor?.quantityFrom} {scrap.quantityUnit})
            <span className="black-text"> To </span>{pickup?.currency}
            {scrap?.priceChange?.processor?.to || scrap?.price} /Kg (
            {scrap?.priceChange?.processor?.quantityTo} {scrap.quantityUnit})
          </p>
        </div>
      )}

      {scrap?.priceChange?.generator?.to && (
        <div
          className="green-text align-center p-1 green lighten-5 mt-1 "
          style={{ borderRadius: 10, border: "1px solid #4caf50" }}
        >
          <p>
            <span className="black-text">
              Trader countered your offer from{" "}
            </span>{" "}
            : {pickup?.currency}{scrap?.priceChange?.generator?.from || scrap?.price} /Kg (
            {scrap?.priceChange?.generator?.quantityFrom} {scrap.quantityUnit})
            <span className="black-text"> To </span>{pickup?.currency}
            {scrap?.priceChange?.generator?.to || scrap?.price} /Kg (
            {scrap?.priceChange?.generator?.quantityTo} {scrap.quantityUnit})
          </p>
        </div>
      )}

      <div className="flex align-center gap-1 justify-end mt-2">
        <button
          className="btn-outline"
          modal={"close"}
          onClick={() => {
            let elem = document.getElementById(pickup._id + "-counter-price");
            let instance = window.M.Modal.getInstance(elem);
            instance.close();
          }}
        >
          Cancel
        </button>

        <button
          className="btn"
          onClick={sendCounterPrice}
          disabled={pickupPriceLoading || !price || !quantity}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

const styles = {
  card: {
    width: 80,
    height: 80,
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
  },
};
